<template>
  <BaseWorkPageLayout :title="$t('global.activities')" icon="file-alt">
    <template #default>
      <ActivityTable :activities="workActivities" />
    </template>
  </BaseWorkPageLayout>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'

export default {
  name: 'TheWorkActivitiesPage',
  computed: { ...mapGetters({ workActivities: 'work/getWorkActivities' }) },
  methods: {
    ...mapActions({ fetchWorkActivities: 'work/fetchWorkActivities' })
  },
  beforeMount() {
    this.fetchWorkActivities({ work_id: this.$route.params.id })
  }
}
</script>
